module.exports = __webpack_public_path__ + "img/product-9.ab256033.jpg";